const getReferrer = (): string => document.referrer;

export { getReferrer };
